import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=22e4b2fe&scoped=true"
import script from "./Conversation.vue?vue&type=script&lang=ts"
export * from "./Conversation.vue?vue&type=script&lang=ts"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=22e4b2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e4b2fe",
  null
  
)

export default component.exports